import { getUITranslation } from "../utils/get_ui_translation";

$(function () {
  $(document)
    .on("mousedown", ".action-specialty select", onShowPicker)
    .on("click", ".pick-specialty-form .specialty", onPick)
    .on("click", ".pick-specialty-form .cancel", onHidePicker);
});

function onShowPicker(e) {
  e.preventDefault();
  onHidePicker(e);
  showPicker();
}

function onHidePicker(e) {
  e.preventDefault();
  e.stopPropagation();
  $(".pick-specialty-form").remove();
}

function onPick(e) {
  onHidePicker(e);
  const $e = $(this);
  const code = $e.find(".code").html();
  $(".action-specialty select").val(code);
}

function showPicker() {
  let { codes, specialties } = makeSpecialtiesLinks(window.bpf_specialties);
  let classicSpecialties = makeClassicSpecialties(codes);

  $("body").append(`
    <div class="pick-specialty-form">
      <div class="content">

        <div class="specialties">
          <div class="scrollable">
            <div class="left">
              <p>${getUITranslation("Domaines courants")}</p>
              ${classicSpecialties}
            </div>
            <div class="right">
              <p>${getUITranslation("Tous les domaines")}</p>
              ${specialties}
            </div>
          </div>
        </div>

        <div class="buttons">
          <button class="button button--secondary button--xs cancel">${getUITranslation("Annuler")}</button>
        </div>

      </div>
    </div>
  `);
}

function makeSpecialtiesLinks(specialties) {
  let str = "";
  const allCodes = {};
  specialties.forEach(([code, name]) => {
    str += makeSpecialtyLink(code, name);
    allCodes[code] = name;
  });
  return { codes: allCodes, specialties: str };
}

function makeSpecialtyLink(code, name) {
  let level = countZeros(code);
  let codes = {};
  codes[code] = name;

  return `
    <button class="specialty level-${level}">
      <span class="code">${code}</span>
      <span class="name">${name}</span>
    </button>`;
}

function countZeros(code) {
  if (code === "999" || code == "410") {
    return 2;
  }
  let count = 0;
  for (var c of code) {
    if (c == "0") ++count;
  }
  return count;
}

function makeClassicSpecialties(codes) {
  let str = "";
  for (var code of window.bpf_classic_specialties) {
    let name = codes[code];
    str += `
    <button class="specialty">
      <span class="code">${code}</span>
      <span class="name">${name}</span>
    </button>`;
  }
  return str;
}
